import { render, staticRenderFns } from "./SafetyObservationForm.vue?vue&type=template&id=14483482&"
import script from "./SafetyObservationForm.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports